export enum RecordSource {
  Pr = 'snpResearch',
  Crm = 'crm',
  PrCrm = 'snpCrm'
}
